import SmartComponent from '../utils/smart-component';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/root-reducer';
import AppModal from './app-modal.component';
import { Button } from 'reactstrap';
import { closeModal } from 'redux/message-modal-slice';
import 'styles/app-styles.scss';
import 'styles/message-modal.scss';

interface IMessageModalProps {
    title?: string;
    body?: string;
    isVisible?: boolean;
    onClickOk?: () => void;
}

const useInitialState = (): IMessageModalProps => {
    const { title, body = null, onClickOk, isVisible = false } = useSelector((state: RootState) => state.messageModal);

    return {
        title,
        body,
        onClickOk,
        isVisible,
    };
};

const useRenderDesktop = ({
    title,
    onClickOk = () => {
        /* do nothing */
    },
    body,
    isVisible,
}: IMessageModalProps): JSX.Element => {
    const dispatch = useDispatch();

    const footer = (
        <Button
            color="primary"
            className="rounded-pill"
            onClick={() => {
                dispatch(closeModal());

                if (typeof onClickOk === 'function') {
                    onClickOk();
                }
            }}
        >
            OK
        </Button>
    );

    return isVisible ? (
        <AppModal
            className="justify-content-center message-modal"
            isOpen={isVisible}
            header={<>{title ? title : null}</>}
            footer={footer}
            footerClassName="d-flex justify-content-center theme-green"
            close={onClickOk}
        >
            <div className="d-flex justify-content-center">{body}</div>
        </AppModal>
    ) : null;
};

export { useInitialState, useRenderDesktop as MessageModalDesktop };

export default SmartComponent<Record<string, never>, IMessageModalProps>(useInitialState, useRenderDesktop);
